import { CompliantStateType } from '@csp/dmdp-api-user-dto';
import { Maybe } from '../../../common/model/Monadish';
import { ZonedDateTime } from '../../../datetime/ZonedDateTime';
import { ComplianceMetricItem } from './ComplianceMetricItem';

export type Compliance = {
  // `state` refers to total compliance
  state: CompliantStateType;
  recentState: Maybe<CompliantStateType>;
  updatedAt: ZonedDateTime;
  // Derived from the last lastSync date for all compliance metrics
  lastSync: Maybe<ZonedDateTime>;
  // Derived from the last lastSync date for metrics with recent compliance
  recentLastSync: Maybe<ZonedDateTime>;
  metrics: ComplianceMetricItem[];
};

export const emptyCompliance: Compliance = {
  state: CompliantStateType.NO_DATA,
  recentState: undefined,
  updatedAt: {
    unixTimeMillis: 0,
    zone: 'UTC',
  },
  lastSync: undefined,
  recentLastSync: undefined,
  metrics: [],
};
